import { OrderDTO } from 'interfaces';

export const getExternalCommercialNetworkNumbers = (order: OrderDTO) => {
   if (order.externalCommercialNetworkNumbers?.length) {
      return order.externalCommercialNetworkNumbers.join(', ');
   }
   return '-';
};
